export enum UserRolesEnum {
  SUPERADMIN = 'SuperAdmin',
  ADMIN = 'Admin',
}

export const PRIORITIZED_USER_ROLES: UserRolesEnum[] = [
  UserRolesEnum.SUPERADMIN,
  UserRolesEnum.ADMIN,
]
